<div *ngIf="newHomePedirDelivery" class="new-design">
	<div id="menu-list" style="position: relative">
		<div *ngIf="featuredVisible.length">
			<div class="category-header">
				<h1 id="featuredItems" class="category-name">{{featuredItemsCategoryName}}</h1>
			</div>
			<div class="featured-carousel" appDragScroll>
				<ng-container *ngFor="let item of featuredVisible; trackBy: trackById">
					<span style="position: relative">
						<card
							[item]="item"
							[isFeatured]="true"
							[newHomePedirDelivery]="newHomePedirDelivery"
						></card>
					</span>
				</ng-container>
			</div>
		</div>
	</div>

	<div *ngIf="combosVisible.length">
		<div class="category-header">
			<h1 id="combos" class="category-name">{{comboCategoryName}}</h1>
		</div>
		<span *ngFor="let item of combosVisible; trackBy: trackById" style="position: relative">
			<card
				style="width: 100%"
				[item]="item"
				[newHomePedirDelivery]="newHomePedirDelivery"
			></card>
		</span>
	</div>

	<div *ngIf="pizzaSizesVisible.length">
		<div class="category-header">
			<h1 id="pizzas" class="category-name">{{pizzaCategoryName}}</h1>
		</div>
		<span *ngFor="let item of pizzaSizesVisible; trackBy: trackById" style="position: relative">
			<card style="width: 100%" [item]="item" [newHomePedirDelivery]="newHomePedirDelivery">
			</card>
		</span>
	</div>

	<div
        *ngFor="let view of generalView | slice:0:visibleGeneralLimit; trackBy: trackByCategory"
		style="position: relative"
		id="{{view.category.name}}-{{view.category.id}}"
	>
		<div *ngIf="view.products.length" class="scroll-category">
			<div class="category-header">
				<h1 [id]="view.category.id" class="category-name">{{view.category.name}}</h1>
				<p *ngIf="view.hasDescription && !isInstagramUA" class="text-wrap category-description" [innerHTML]="view.descriptionHtml"></p>
				<p *ngIf="view.hasDescription && isInstagramUA" class="text-wrap category-description">{{view.descriptionText}}</p>
			</div>
			<span *ngFor="let prod of view.products; trackBy: trackById" style="position: relative">
				<card
					style="width: 100%"
					[item]="prod"
					[newHomePedirDelivery]="newHomePedirDelivery"
				></card>
			</span>
		</div>
	</div>
</div>

<ion-list id="menu-list" style="position: relative" *ngIf="!newHomePedirDelivery">
	<ion-item-group *ngIf="featuredVisible.length">
		<h1 id="featuredItems" class="category-name">{{featuredItemsCategoryName}}</h1>
		<span *ngFor="let item of featuredVisible; trackBy: trackById" style="position: relative">
			<card
				style="width: 100%"
				[item]="item"
				[newHomePedirDelivery]="newHomePedirDelivery"
			></card>
		</span>
	</ion-item-group>

	<ion-item-group *ngIf="combosVisible.length">
		<h1 id="combos" class="category-name">{{comboCategoryName}}</h1>
		<span *ngFor="let item of combosVisible; trackBy: trackById" style="position: relative">
			<card
				style="width: 100%"
				[item]="item"
				[newHomePedirDelivery]="newHomePedirDelivery"
			></card>
		</span>
	</ion-item-group>

	<ion-item-group *ngIf="pizzaSizesVisible.length">
		<h1 id="pizzas" class="category-name">{{pizzaCategoryName}}</h1>
		<span *ngFor="let item of pizzaSizesVisible; trackBy: trackById" style="position: relative">
			<card style="width: 100%" [item]="item" [newHomePedirDelivery]="newHomePedirDelivery">
			</card>
		</span>
	</ion-item-group>

	<ion-item-group
        *ngFor="let view of generalView | slice:0:visibleGeneralLimit; trackBy: trackByCategory"
		style="position: relative"
		id="{{view.category.name}}-{{view.category.id}}"
	>
		<div *ngIf="view.products.length"  class="scroll-category">
			<h1 [id]="view.category.id" class="category-name">{{view.category.name}}</h1>
			<ion-label *ngIf="view.hasDescription && !isInstagramUA" class="text-wrap category-description"><span [innerHTML]="view.descriptionHtml"></span></ion-label>
			<ion-label *ngIf="view.hasDescription && isInstagramUA" class="text-wrap category-description">{{view.descriptionText}}</ion-label>
			<span *ngFor="let prod of view.products; trackBy: trackById" style="position: relative">
				<card
					style="width: 100%"
					[item]="prod"
					[newHomePedirDelivery]="newHomePedirDelivery"
				></card>
			</span>
		</div>
	</ion-item-group>
</ion-list>

<app-featured-coupon-popup></app-featured-coupon-popup>
